"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Authenticator = void 0;
const philae_1 = require("../../private/api-services/philae");
const authData_1 = require("../../private/ephemeral/authData");
const falconone_1 = require("../../private/api-services/falconone");
class Authenticator {
    constructor() {
        this.philae = new philae_1.Philae(false);
        this.falconOne = new falconone_1.FalconOne(false);
    }
    /**
     * @param username
     * @param password
     */
    authenticateUsingCredentials(username, password, application = false) {
        return new Promise((resolve, reject) => {
            this.falconOne
                .post("user/auth", {
                password: password,
                username: username,
                application
            })
                .then((response) => {
                resolve(response);
                authData_1.Auth.setUserToken(response.id_token);
                authData_1.Auth.setRefreshToken(response.refresh_token);
                authData_1.Auth.setAccessToken(response.access_token);
                this.falconOne = new falconone_1.FalconOne(response.id_token);
                // deprecated
                this.philae = new philae_1.Philae(response.id_token);
            })
                .catch(() => {
                reject(false);
                console.log("Authentication failed");
            });
        });
    }
    authenticateUsingToken(token) {
        authData_1.Auth.setUserToken(token);
        this.philae = new philae_1.Philae(token);
    }
    exchangeCode(code, redirect_uri, application) {
        return new Promise((resolve, reject) => {
            this.falconOne.post('/user/auth/token', {
                code,
                redirect_uri,
                application
            })
                .then((response) => {
                resolve(response);
                authData_1.Auth.setUserToken(response.id_token);
                authData_1.Auth.setRefreshToken(response.refresh_token);
                authData_1.Auth.setAccessToken(response.access_token);
                this.falconOne = new falconone_1.FalconOne(response.id_token);
            })
                .catch(() => {
                reject("Code Exchange Authentication failed");
                throw new Error("Authentication failed");
            });
        });
    }
    refreshToken(refreshToken, application) {
        return new Promise((resolve, reject) => {
            this.falconOne.post('/user/refreshToken', {
                refreshToken,
                application
            })
                .then((response) => {
                resolve(response);
                authData_1.Auth.setUserToken(response.id_token);
                authData_1.Auth.setAccessToken(response.access_token);
                authData_1.Auth.setRefreshToken(refreshToken);
                this.falconOne = new falconone_1.FalconOne(response.id_token);
            })
                .catch(() => {
                reject("Refresh Token Failed");
                // throw new Error("Authentication failed");
            });
        });
    }
    // deprecated / inactive
    authenticateAsGuest() {
        return new Promise((resolve, reject) => {
            this.philae.post("guests", {}).then((token) => {
                resolve(token);
                authData_1.Auth.setUserToken(token);
                this.philae = new philae_1.Philae(token);
            }).catch(() => {
                reject(false);
                console.log("Guest authentication failed");
                throw new Error("Authentication failed");
            });
        });
    }
    openDomain(domainUuid) {
        return new Promise((resolve, reject) => {
            this.falconOne
                .get(`/domain/${domainUuid}/token`)
                .then((token) => {
                authData_1.Auth.setDomainToken(token);
                resolve(token);
            })
                .catch(() => {
                reject(false);
                console.log("Domain authentication failed, user likely does not have access to domain " + domainUuid);
                throw new Error("domain auth failed");
            });
        });
    }
    setDomainToken(token) {
        authData_1.Auth.setDomainToken(token);
    }
    getDomainToken() {
        return authData_1.Auth.getDomainToken();
    }
    getUserToken() {
        return authData_1.Auth.getUserToken();
    }
    setUserToken(idToken) {
        authData_1.Auth.setUserToken(idToken);
    }
    setUserAccessToken(accessToken) {
        authData_1.Auth.setAccessToken(accessToken);
    }
    getUserAccessToken() {
        return authData_1.Auth.getUserAccessToken();
    }
    setUserRefreshToken(refreshToken) {
        authData_1.Auth.setRefreshToken(refreshToken);
    }
    // public getUserRefreshToken(): string|boolean {
    //   return Auth.getUserAccessToken();
    // }
    authenticateGuest() {
        return new Promise((resolve, reject) => {
            this.falconOne.post("user/guest", {}).then((response) => {
                resolve(response);
                authData_1.Auth.setUserToken(response.id_token);
                authData_1.Auth.setAccessToken(response.access_token);
            }).catch(() => {
                reject(false);
                console.log("Guest authentication failed");
                throw new Error("Authentication failed");
            });
        });
    }
}
exports.Authenticator = Authenticator;
//# sourceMappingURL=data:application/json;base64,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